import React from 'react';
import { CheckIcon } from 'lucide-react';
const Pricing = () => {
  return <section id="pricing" className="bg-gray-50 py-16" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="text-center mb-12" data-id="element-257">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-258">
            EICR Pricing
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-259">
            Transparent pricing for all your electrical safety certificate
            needs. No hidden fees or surprises.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-260">
          {/* Residential Pricing */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-261">
            <div className="bg-blue-600 text-white p-6 text-center" data-id="element-262">
              <h3 className="text-xl font-bold mb-2" data-id="element-263">Residential EICR</h3>
              <p className="opacity-90 mb-4" data-id="element-264">For homeowners and landlords</p>
              <div className="flex justify-center items-end" data-id="element-265">
                <span className="text-3xl font-bold" data-id="element-266">£149</span>
                <span className="ml-1 text-sm opacity-90" data-id="element-267">+ VAT</span>
              </div>
            </div>
            <div className="p-6" data-id="element-268">
              <ul className="space-y-3 mb-6" data-id="element-269">
                <li className="flex items-start" data-id="element-270">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-271" />
                  <span className="text-gray-700" data-id="element-272">Up to 10 circuits</span>
                </li>
                <li className="flex items-start" data-id="element-273">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-274" />
                  <span className="text-gray-700" data-id="element-275">Digital certificate</span>
                </li>
                <li className="flex items-start" data-id="element-276">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-277" />
                  <span className="text-gray-700" data-id="element-278">Valid for 5 years</span>
                </li>
                <li className="flex items-start" data-id="element-279">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-280" />
                  <span className="text-gray-700" data-id="element-281">48-hour turnaround</span>
                </li>
              </ul>
              <a href="#contact" className="block text-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors" data-id="element-282">
                Book Now
              </a>
            </div>
          </div>
          {/* Commercial Pricing */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden relative" data-id="element-283">
            <div className="absolute top-0 right-0 bg-yellow-500 text-blue-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-284">
              MOST POPULAR
            </div>
            <div className="bg-blue-700 text-white p-6 text-center" data-id="element-285">
              <h3 className="text-xl font-bold mb-2" data-id="element-286">Commercial EICR</h3>
              <p className="opacity-90 mb-4" data-id="element-287">For offices and retail spaces</p>
              <div className="flex justify-center items-end" data-id="element-288">
                <span className="text-3xl font-bold" data-id="element-289">£199</span>
                <span className="ml-1 text-sm opacity-90" data-id="element-290">+ VAT</span>
              </div>
            </div>
            <div className="p-6" data-id="element-291">
              <ul className="space-y-3 mb-6" data-id="element-292">
                <li className="flex items-start" data-id="element-293">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-294" />
                  <span className="text-gray-700" data-id="element-295">Up to 20 circuits</span>
                </li>
                <li className="flex items-start" data-id="element-296">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-297" />
                  <span className="text-gray-700" data-id="element-298">
                    Digital & printed certificate
                  </span>
                </li>
                <li className="flex items-start" data-id="element-299">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-300" />
                  <span className="text-gray-700" data-id="element-301">Valid for 5 years</span>
                </li>
                <li className="flex items-start" data-id="element-302">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-303" />
                  <span className="text-gray-700" data-id="element-304">24-hour turnaround</span>
                </li>
              </ul>
              <a href="#contact" className="block text-center bg-blue-700 hover:bg-blue-800 text-white font-medium py-2 px-4 rounded transition-colors" data-id="element-305">
                Book Now
              </a>
            </div>
          </div>
          {/* Industrial Pricing */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-306">
            <div className="bg-blue-800 text-white p-6 text-center" data-id="element-307">
              <h3 className="text-xl font-bold mb-2" data-id="element-308">Industrial EICR</h3>
              <p className="opacity-90 mb-4" data-id="element-309">For factories and warehouses</p>
              <div className="flex justify-center items-end" data-id="element-310">
                <span className="text-3xl font-bold" data-id="element-311">Custom</span>
              </div>
            </div>
            <div className="p-6" data-id="element-312">
              <ul className="space-y-3 mb-6" data-id="element-313">
                <li className="flex items-start" data-id="element-314">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-315" />
                  <span className="text-gray-700" data-id="element-316">Custom assessment</span>
                </li>
                <li className="flex items-start" data-id="element-317">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-318" />
                  <span className="text-gray-700" data-id="element-319">
                    Digital & printed certificate
                  </span>
                </li>
                <li className="flex items-start" data-id="element-320">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-321" />
                  <span className="text-gray-700" data-id="element-322">Valid for 3-5 years</span>
                </li>
                <li className="flex items-start" data-id="element-323">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-324" />
                  <span className="text-gray-700" data-id="element-325">Priority scheduling</span>
                </li>
              </ul>
              <a href="#contact" className="block text-center bg-blue-800 hover:bg-blue-900 text-white font-medium py-2 px-4 rounded transition-colors" data-id="element-326">
                Get Quote
              </a>
            </div>
          </div>
        </div>
        <div className="mt-10 bg-white p-6 rounded-lg shadow-md" data-id="element-327">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-328">
            Additional Services
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-329">
            <div className="border rounded-md p-4" data-id="element-330">
              <h4 className="font-semibold text-gray-800 mb-2" data-id="element-331">
                Same-Day Certificate
              </h4>
              <p className="text-gray-600 mb-2" data-id="element-332">For urgent requirements</p>
              <p className="text-blue-600 font-semibold" data-id="element-333">+ £75</p>
            </div>
            <div className="border rounded-md p-4" data-id="element-334">
              <h4 className="font-semibold text-gray-800 mb-2" data-id="element-335">
                Additional Circuits
              </h4>
              <p className="text-gray-600 mb-2" data-id="element-336">Per 5 extra circuits</p>
              <p className="text-blue-600 font-semibold" data-id="element-337">+ £30</p>
            </div>
            <div className="border rounded-md p-4" data-id="element-338">
              <h4 className="font-semibold text-gray-800 mb-2" data-id="element-339">
                Weekend Inspection
              </h4>
              <p className="text-gray-600 mb-2" data-id="element-340">Saturday or Sunday service</p>
              <p className="text-blue-600 font-semibold" data-id="element-341">+ £50</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Pricing;